import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

import prevArrow from '../../../images/back-arrow-left.svg';
import nextArrow from '../../../images/back-arrow-right.svg';

export const CarouselContainer = styled.div`
  margin: 20px;
  .swiper {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: clip;
    overflow-x: visible;

    .swiper-wrapper {
      display: flex;
      justify-content: flex-start;
      padding: 1.5rem 0 2rem;

      .swiper-slide {
        display: flex;
        height: auto;
        justify-content: center;
      }
    }
    .swiper-button-next,
    .swiper-button-prev {
      height: 2.5rem;
      width: 2.5rem;
      border-radius: 1.25rem;
      border: 2px solid ${themeGet('colors.white')};
      box-shadow: 0 2px 5px 0 rgb(0 0 0 / 30%);
      cursor: pointer;
      transition:
        border 400ms ease,
        opacity 400ms ease;

      &.swiper-button-disabled {
        opacity: 0;
        visibility: hidden;
      }

      &:after {
        content: none;
      }

      &:hover,
      &:focus {
        border: 2px solid ${themeGet('colors.stone')};
      }
    }

    .swiper-button-next {
      background-image: url(${nextArrow});
      right: 24px;
    }

    .swiper-button-prev {
      background-image: url(${prevArrow});
      left: 24px;
    }

    .swiper-pagination {
      margin: 1.25rem auto;
    }

    .swiper-pagination-bullet {
      display: inline-block;
      width: 0.75rem;
      height: 0.75rem;
      text-align: center;
      line-height: 0.75rem;
      font-size: 0.75rem;
      opacity: 1;
      background: ${themeGet('colors.bullet-grey')};
    }

    .swiper-pagination-bullet-active {
      background: ${themeGet('colors.esso-red')};
    }
  }

  .far-out-button {
    .swiper-button-next {
      right: -12px;
    }

    .swiper-button-prev {
      left: -12px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 20px 14px;

    .swiper {
      .swiper-button-next {
        right: 8px;
      }

      .swiper-button-prev {
        left: 8px;
      }

      .far-out-button {
        .swiper-button-next {
          right: -16px;
        }

        .swiper-button-prev {
          left: -16px;
        }
      }
    }
  }
`;
